<template>
  <div class="welcome-view-container">
    <div class="title-view">
      <img src="/static/mmm-logo-text-min.png" title="Mr. Meet Maps">
    </div>
    <div class="welcome-view">
      <div v-for="option in options"
           v-bind:key="option.id"
           @click="selectOption(option)"
           class="option"
           :class="option.id"
           :style="{ backgroundImage: 'url(' + option.logo + ')' }">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data () {
    return {
      options: [{
        id: 'diving',
        name: 'Diving',
        logo: require('@/assets/images/welcome/diving.png'),
      // }, {
      //   id: 'weightlifting',
      //   name: 'Weightlifting',
      //   logo: require('@/assets/images/welcome/weightlifting.jpg'),
      // }]
      }]
    }
  },
  methods: {
    selectOption(opt) {
      this.$store.commit('setSport', opt.id)
      this.$router.push(opt.id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
html, body, #app, .welcome-view-container {
  height: 100%;
}

/* START FLEX LAYOUT */
body {
  display: flex;
  flex-direction: column;
  .welcome-view-container {
    flex: 1;
    .title-view {
      height: 18%;
    }
    .welcome-view {
      display: flex;
      height: 82%;
      overflow: hidden; // If removed, the hover scaling will make window scrollable
      .option {
        flex: 1;
      }
    }
  }
}
/* END FLEX LAYOUT */

.title-view {
  padding: 0.5rem;
  text-align: center;
  width: 100%;
  img {
    width: 100%;
    max-width: 700px;
  }
}

.welcome-view {
  .option, .title-view {
    cursor: pointer;
    font-size: 2.5rem;
    color: #fff;

    transition: color 0.5s, scale 0.5s;

    background-repeat: no-repeat;
    background-position: center;

    &:hover {
      transform: scale(1.1);
      color: rgb(33, 37, 41);
    }
    // Testing inverted colors (yin-yang)
    // &:nth-child(even) {
      // filter: invert(100%);
      // background-color: #fff;
    // }
  }
}

@media screen and (max-width: 1010px) {
  body {
    .welcome-view-container .welcome-view {
      flex-direction: column;
      .option.weightlifting {
        flex: 1.5;
      }
    }
  }
}

@media screen and (min-height: 957px) {
  body .welcome-view-container .welcome-view .option {
    background-size: auto;
  }
}

@media screen and (min-height: 638px) and (max-height: 957px) {
  body .welcome-view-container .welcome-view .option {
    background-size: 65%;
  }
}

@media screen and (max-width: 375px) , screen and (max-height: 638px) {
  body .welcome-view-container .welcome-view .option {
    background-size: 50%;
  }
}

@media screen and (max-width: 540px) {
  body .welcome-view-container {
    .title-view {
      height: 16%;
    }
    .welcome-view {
      flex-direction: column;
      height: 84%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue